import React, { useState, useEffect } from "react";
import app from "nystem";
import { Wrapper, ContentTypeRender, useUser } from "nystem-components";

const SessionUseraccess = ({ model, view, path }) => {
  const [visible, setVisible] = useState(undefined);
  const user = useUser();

  useEffect(() => {
    const insertVal = (p1) => {
      if (p1 === "_language") return app.settings.lang;
      if (p1 === "id") return view.id;
      if (p1.indexOf("baseView.") !== 0)
        return view.getValue(p1.replace("..", path));
      p1 = p1.replace("baseView.", "");
      return view.baseView.getValue(p1.replace("..", path));
    };

    const setVisibility = async () => {
      let productId = insertVal(model.productId);
      // eslint-disable-next-line prefer-destructuring
      if (productId instanceof Array) productId = productId[0];
      const { value } = view;

      const { data: program } = await app.database.program.get({
        id: productId,
      });

      if (program?.type === "free" && !value.productoptions) return true;
      if (!user) return false;
      const { access, role } = user;
      if (["usertype2", "config", "super"].includes(role)) return true;
      if (!access) return false;
      if (access.includes(productId) || access.includes(value._id)) return true;

      const { data } = await app.database.product.search({
        filter: { _id: access, $and: [{ program: productId }] },
        count: 1,
        role: "super",
      });
      if (!data) return false;
      const [product] = data;

      if (view.contentType === "program" && product.program[0] === value._id)
        return true;

      const now = new Date();
      return (
        now.setMonth(now.getMonth() - product.lockAfter) < value.publishDate
      );
    };
    // eslint-disable-next-line no-bitwise
    (async () => setVisible(model.invert ^ (await setVisibility())))();
  }, [model, path, user, view]);

  if (visible === undefined) return null;

  if (!visible)
    return model.noaccess?.length ? (
      <Wrapper className={model.className}>
        <ContentTypeRender path={path} items={model.noaccess} />
      </Wrapper>
    ) : null;

  return (
    <Wrapper className={model.className}>
      <ContentTypeRender path={path} items={model.item} />
    </Wrapper>
  );
};

export default SessionUseraccess;
